import { BrowserRouter, Route, Routes } from 'react-router';

import { Signin } from './views/Signin';
import { Password } from './views/Password';

import { ValidatingCompany } from './views/admin/company/ValidatingCompany';
import { BlockedCompany } from './views/admin/company/BlockedCompany';
import { ValidateCompany } from './views/admin/company/ValidateCompany';
import { Companies } from './views/admin/company/Companies';
import { Withdraws } from './views/admin/company/Withdraws';
import { Stat } from './views/admin/company/Stat';
import { Services } from './views/admin/service/Services';
import { Notifications } from './views/admin/notification/Notifications';
import { Users } from './views/admin/user/Users';
import { ValidatingProperty } from './views/admin/genrality/ValidatingProperty';
import { UnvalidatedProperties } from './views/admin/genrality/UnvalidatedProperties';
import { Configurations } from './views/admin/genrality/Configurations';
import { MoreDetails } from './views/admin/genrality/MoreDetails';
import { Error } from './views/Error';
import ProtectedRoute from './route/ProtectedRoute';

function App() {
  return (

      <div className="App">
       
        <BrowserRouter>
            <Routes>

                <Route exact path="/" element={ <Signin /> }> </Route>

                <Route exact path="/mot-de-passe-oublie" element={ <Password /> }> </Route> 

                {/* Toutes les routes protégées */}
                <Route element={<ProtectedRoute />}>

                    <Route exact path="/admin" element={ <ValidatingProperty /> }> </Route>
                    <Route exact path="/admin/propriete-invalide" element={ <UnvalidatedProperties /> }> </Route>
                    <Route exact path="/admin/configuration/:propertyId" element={ <Configurations /> }> </Route>
                    <Route exact path="/admin/details/:propertyId" element={ <MoreDetails /> }> </Route>

                    <Route exact path="/admin/services" element={ <Services /> }> </Route>

                    <Route exact path="/admin/entreprise" element={ <Companies /> }> </Route>
                        <Route exact path="/admin/retrait/:companyId" element={ <Withdraws /> }> </Route>
                        <Route exact path="/admin/solde/:companyId" element={ <Stat /> }> </Route>
                    <Route exact path="/admin/entreprise-en-cours-validation" element={ <ValidatingCompany /> }> </Route>
                        <Route exact path="/admin/entreprise/:companyId" element={ <ValidateCompany /> }> </Route>
                    <Route exact path="/admin/entreprise-bloque" element={ <BlockedCompany /> }> </Route>

                    <Route exact path="/admin/notification" element={ <Notifications /> }> </Route>
                
                    <Route exact path="/admin/parametre" element={ <Users /> }> </Route>

                </Route>
    
               
                <Route path="/404" element={<Error />} />
                <Route path="*" element={<Error />} />

            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
